import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideModal,
  createCliente,
  updateCliente,
  deleteCliente,
} from "../../store/actions/clientes";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import { ErrorMessage } from "../../components/ErrorMessage";

import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import InputField from "../../components/InputField";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import { useStyles } from '../../lib/styles/nuevoStyles';

import {
  clientesForm,
  defaultVal,
  validation,
} from "../../lib/forms/clientesForm";

export const NuevoCliente = () => {
  const showModal = useSelector((state) => state.clientes.showModal);
  const page = useSelector((state) => state.clientes.page);
  const pageSize = useSelector((state) => state.clientes.pageSize);
  const dataBuscar = useSelector((state) => state.clientes.dataBuscar);
  const cliente = useSelector((state) => state.clientes.cliente);
  const editMode = useSelector((state) => state.clientes.editMode);
  const isLoading = useSelector((state) => state.clientes.isLoading);
  const error = useSelector((state) => state.clientes.error);
  const dispatch = useDispatch();

  const classes = useStyles();

  const formModel = clientesForm();
  const defaultValues = defaultVal();
  const validationSchema = validation();

  const { control, handleSubmit, errors } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onChange",
    defaultValues: editMode ? cliente : defaultValues,
  });

  const onDelete = () => {
    const id = cliente.id;
    if (
      window.confirm(
        `Esta seguro que desea borrar el cliente ${cliente.nombre}?`
      )
    ) {
      dispatch(deleteCliente({ id, page, pageSize, dataBuscar }));
    }
  };

  const onSubmit = (data) => {
    data = {
      ...data,
    };
    const id = cliente.id;
    if (editMode) {
      dispatch(updateCliente({ id, data, page, pageSize, dataBuscar }));
    } else {
      dispatch(createCliente({ data, pageSize }));
    }
  };

  return (
    <Dialog
      open={showModal}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          dispatch(hideModal());
        }
      }}
      fullWidth
      maxWidth="sm"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>
          {editMode ? "Editar Cliente" : "Agregar Nuevo Cliente"}
        </DialogTitle>
        <DialogContent>
          <div className={classes.root}>
            <Grid container spacing={2}>
              {formModel.map((input) => (
                <Grid item key={input.props.name} md={input.width} xs={12}>
                  <InputField
                    {...input.props}
                    control={control}
                    errors={errors}
                  />
                </Grid>
              ))}
            </Grid>
          </div>
          {error && <ErrorMessage module="clientes" />}
        </DialogContent>
        <DialogActions>
          {editMode && (
            <Button onClick={onDelete} className={classes.warning}>
              Borrar Cliente
            </Button>
          )}
          <Button
            onClick={() => dispatch(hideModal())}
            color="primary"
            tabIndex={-1}
          >
            Cancelar
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {editMode ? "Editar" : "Capturar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
